export default class ErrorBag{
    constructor(errors){
        this.errors = [];

        if (errors && Array.isArray(errors)){
            let err = errors.map(e => {
                return {
                    message: e.message,
                    field: e.field
                };
            });
            this.errors.push(...err);
        } else if (errors instanceof ErrorBag){
            this.errors = errors.errors;
        }
    }

    has(field){
        return this.errors.findIndex(e => e.field === field) !== -1;
    }

    getError(field){
        if (this.hasField(field)){
            return this.errors.find(e => e.field === field).message;
        }
    }

    allErrors(){
        return this.errors.map(e => e.message);
    }
}
